import Icon, { FileUnknownFilled } from '@ant-design/icons';
import { ReactComponent as PDFIcon } from 'assets/icons/extensions/pdf.svg';
import { ReactComponent as DOCIcon } from 'assets/icons/extensions/doc.svg';
import { ReactComponent as XLSIcon } from 'assets/icons/extensions/xls.svg';

export const DOCUMENT_FILE_TYPE_ICON = {
  word: <Icon style={{ fontSize: 48 }} component={DOCIcon} />, // <FileWordFilled style={{ color: 'blue' }} />,
  excel: <Icon style={{ fontSize: 48 }} component={XLSIcon} />,
  pdf: <Icon style={{ fontSize: 48 }} component={PDFIcon} />,
  unknown: <FileUnknownFilled style={{ fontSize: 48 }} />
};
